import { takeLatest, call, put } from 'redux-saga/effects';
import {
  SET_EPF_PAYMENT_INQUIRY,
  GET_EPF_PAYMENT_INQUIRY,
} from 'redux/reducers/payment/actionTypes';
import {
  SET_OPEN_TOP_ALERT,
  SET_CONTENT_TOP_ALERT,
} from 'redux/reducers/global/actionTypes';
import { paymentInquiryInfoService } from 'services/payment/paymentApi';

function* requestPaymentInquiryFromEPF(action) {
  const result = yield call(paymentInquiryInfoService, action.body);
  if (result && result.response && result.error) {
    const topAlertContent = {
      iconType: 'la la-exclamation-circle',
      message: `Sorry, ${result.response.status} ${result.response.statusText}`,
      iconClose: 'la la-times',
    };
    yield put({ type: SET_CONTENT_TOP_ALERT, topAlertContent });
    yield put({ type: SET_OPEN_TOP_ALERT });
    return;
  }
  if (!!result) {
    yield put({ type: SET_EPF_PAYMENT_INQUIRY, result });
  }
}
function* getPaymentInquiryInfo() {
  yield takeLatest(GET_EPF_PAYMENT_INQUIRY, requestPaymentInquiryFromEPF);
}

export default getPaymentInquiryInfo;
